export const logos = [
  {
    src: 'https://content.andersenlab.com/common-data/whiteLogo/T-Mobile/1722834629.svg',
    alt: 'T-Systems',
  },
  {
    src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/siemens-white.svg',
    alt: 'Siemens',
  },
  {
    src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/tui/tui-logo-white.svg',
    alt: 'TUI',
  },
];
